export const RESUME_INTO_MAPPING_KEY = 'pipeex-resume-into-mapping';
export const LIVE_WIZARD_MAPPING_HANDOFF_KEY = 'pipeex-live-wizard-mapping-handoff';
export const REINITIATED_WIZARD_MAPPING_HANDOFF_KEY =
  'pipeex-reinitiated-wizard-mapping-handoff';

/** The paired intents distinguish conversion from either normal entry path. */
export function readConvertedSettingsMappingHandoffIntent(): boolean {
  return readResumeIntoMappingIntent() && readLiveWizardMappingHandoffIntent();
}

export function clearConvertedSettingsMappingHandoffIntent(): void {
  clearResumeIntoMappingIntent();
  clearLiveWizardMappingHandoffIntent();
}

export function readResumeIntoMappingIntent(): boolean {
  try {
    return window.sessionStorage.getItem(RESUME_INTO_MAPPING_KEY) === '1';
  } catch {
    return false;
  }
}

export function markResumeIntoMappingIntent(): void {
  try {
    window.sessionStorage.setItem(RESUME_INTO_MAPPING_KEY, '1');
  } catch {
    // Ignore session storage failures; mapping page will skip resume restore.
  }
}

export function clearResumeIntoMappingIntent(): void {
  try {
    window.sessionStorage.removeItem(RESUME_INTO_MAPPING_KEY);
  } catch {
    // Ignore session storage failures; the one-shot intent may survive this session.
  }
}

export function markLiveWizardMappingHandoffIntent(): void {
  try {
    window.sessionStorage.setItem(LIVE_WIZARD_MAPPING_HANDOFF_KEY, '1');
  } catch {
    // Ignore session storage failures; mapping page will fall back to direct-load guards.
  }
}

export function readLiveWizardMappingHandoffIntent(): boolean {
  try {
    return window.sessionStorage.getItem(LIVE_WIZARD_MAPPING_HANDOFF_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearLiveWizardMappingHandoffIntent(): void {
  try {
    window.sessionStorage.removeItem(LIVE_WIZARD_MAPPING_HANDOFF_KEY);
  } catch {
    // Ignore session storage failures; the one-shot intent may survive this session.
  }
}

export function markReinitiatedWizardMappingHandoffIntent(): void {
  try {
    window.sessionStorage.setItem(REINITIATED_WIZARD_MAPPING_HANDOFF_KEY, '1');
  } catch {
    // Ignore session storage failures; live handoff falls back to existing profile guards.
  }
}

export function readReinitiatedWizardMappingHandoffIntent(): boolean {
  try {
    return window.sessionStorage.getItem(REINITIATED_WIZARD_MAPPING_HANDOFF_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearReinitiatedWizardMappingHandoffIntent(): void {
  try {
    window.sessionStorage.removeItem(REINITIATED_WIZARD_MAPPING_HANDOFF_KEY);
  } catch {
    // Ignore session storage failures; the one-shot intent may survive this session.
  }
}
